'use strict';
//***********************************************************************************
//***********************************************************************************
import { cn_add } from '../utils/cn_utilities';
import { cn_svg_tool_edition } from './cn_svg_tool_edition';
import { cn_svg_map } from './cn_svg_map';
import { cn_mmm_element } from '../model/cn_mmm_element';
import { cn_mmm_handler } from './cn_mmm_handler';

/**
 * @class cn_svg_tool_mmm_edition
 * A class to manipulate mmm_elements

 */
export class cn_svg_tool_mmm_edition extends cn_svg_tool_edition {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);
    }

    //***********************************************************************************
    //**** Selection callback
    //***********************************************************************************
    on_selection_change() {
        const obj = this;
        this._handlers = [];

        //*** We expect the selection to contain only openings */
        var sel = this._controller.get_selection();
        if (sel.length == 0 || sel.some(elt => elt.constructor != cn_mmm_element))
            return false;

        this._handlers.push(new cn_mmm_handler(sel, this._map));
        return true;
    }

    //***********************************************************************************
    //**** Group translation
    //***********************************************************************************
    translate(ev, offset) {
        var selection = this._controller.get_selection();
        for (var i in selection) {
            var elt = selection[i];
            if (elt.constructor == cn_mmm_element) {
                this.push_item_set(elt, 'vertices');
                for (var k in elt.vertices)
                    elt.vertices[k] = cn_add(elt.vertices[k], offset);
            }
        }
    }
}

